export default {
  default: () => import("/home/prod/v3/layouts/default.vue")
}